// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-content-map[data-v-715e611c]{width:100%;overflow-x:hidden;padding:0}.ct-wrap[data-v-715e611c]{max-width:clamp(50rem,80vw + 20rem,94.5rem);margin:0 auto;padding:0 clamp(.9375rem,3.5vw,2.875rem)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
